<template>
  <div class="agreement-content"></div>
</template>

<script>
export default {
  mounted() {
    this.downloadAgreement()
  },
  methods: {
    async downloadAgreement() {
      try {
        const { orderId, documentId } = this.$route.query
        let queryParams = documentId ? `?orderId=${orderId}&documentId=${documentId}` : `?orderId=${orderId}`
        const res = await this.$http.post(`/digitsign/download${queryParams}`)
        const fileData = res.data
        const blob = new Blob([fileData], { type: 'application/octet-stream' })
        const linkSource = window.URL.createObjectURL(blob)
        const downloadLink = document.createElement('a')
        const fileName = `f_${generateId()}.pdf`
        downloadLink.href = linkSource
        downloadLink.download = fileName
        downloadLink.click()
        this.$router.back()
      } catch (error) {
        console.log(error)
      }
    },
  },
}

function generateId() {
  return Math.random().toString(36).substring(2, 15) +
    Math.random().toString(36).substring(2, 15)
}
</script>

<style scoped lang="stylus">
.agreement-content
  width 100%
  height 100%
  background #fff

#the-canvas
  width 100vw
  height calc(100vh - 160px)
  overflow-y scroll

.pdf-page
  display flex
  justify-content center
  align-items center

</style>
